// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f6954beb","833":"c5a8268a"}[chunkId] + ".chunk.js";
};